import MyService from '../../service';

const ModelApi = {
  getModelByType: async (typeId) => {
    let result = null;

    await MyService.getRequestData('/vehicles/model', { vhc_type_id: typeId })
      .then((res) => (result = res.data))
      .catch((err) => console.log(err));
    return result;
  },
  getModelByBrand: async (brandId) => {
    let result = null;

    await MyService.getRequestData(
      '/vehicles/model/get-model-vehicle-by-brand',
      { vhc_bran_id: brandId }
    )
      .then((res) => (result = res.data))
      .catch((err) => console.log(err));
    return result;
  },
};
export default ModelApi;
